import {
  TIME_OF_DAY,
  advancePhase01,
  sampleTimeOfDay,
  wrapPhase01,
  type TimeOfDayConfig,
  type TimeOfDayState,
} from '../../../config/atmosphere/timeOfDay.config';

/**
 * TimeOfDayModel — the stateful day/night clock. Advance it with each frame's
 * real dt; read the interpolated atmosphere state. Pure (no rendering/event
 * deps) so it's fully TDD'd; the runtime glue lives in TimeOfDayDriver.
 *
 * Mirrors CombatMoodModel: a thin stateful wrapper over the pure math in
 * `config/atmosphere/timeOfDay.config.ts`.
 */
export class TimeOfDayModel {
  private phase: number;

  constructor(private readonly cfg: TimeOfDayConfig = TIME_OF_DAY) {
    this.phase = wrapPhase01(cfg.startPhase01);
  }

  /** Advance the clock by a real-frame dt (ms). Ignores non-positive dt. */
  tick(dtMs: number): void {
    if (dtMs > 0) this.phase = advancePhase01(this.phase, dtMs, this.cfg);
  }

  /** Current raw clock phase, 0..1 (0 = midnight, 0.5 = noon). */
  get phase01(): number {
    return this.phase;
  }

  /** The interpolated atmosphere state at the current phase. */
  state(): TimeOfDayState {
    return sampleTimeOfDay(this.phase);
  }

  /** Jump the clock to a phase (debug/QA + tests). Wrapped into [0,1). */
  setPhase01(p: number): void {
    this.phase = wrapPhase01(p);
  }
}
